import { render, staticRenderFns } from "./AwardRankingHeaderSection.vue?vue&type=template&id=c7e9827e&scoped=true"
import script from "./AwardRankingHeaderSection.vue?vue&type=script&lang=ts"
export * from "./AwardRankingHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./AwardRankingHeaderSection.vue?vue&type=style&index=0&id=c7e9827e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e9827e",
  null
  
)

export default component.exports